import styled from "styled-components";
import React, { useState } from 'react';
import Switch from "react-switch";

// ||
export const StyledButton = styled.button`
cursor: pointer;
margin: 0 5px;
margin-right: 25px;
color:  ${props => props.color || "white"}; 
padding: 12px 35px;
border-radius: 6px;
font-weight: 500;
font-size: 18px;
border: 1px solid #377DFF;
cursor: pointer;
background-color:  ${props => props.bgColor  || "#377DFF"}; 
&:hover {

               border: 0.125rem solid #377DFF;
           
        }
`

const Button =  ({children , bgColor, color}) => {
  return (
    <StyledButton  bgColor={bgColor} color={color} >{children}</StyledButton>
    
  );
}

export default Button;




export const SwitchBtn = () => {
  const[state,setState] =useState({ checked: false})

 function handleChange(checked) {
    setState({ checked });
  }
  return (
    <label>
    {/* <span>Switch with default style</span> */}
    <Switch onColor='#A0A9B0' uncheckedIcon onChange={handleChange} checked={state.checked} />
  </label>
  )
}

